var _style, _path, _path2, _circle, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "trash_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".trash_svg__st4,.trash_svg__st5{fill:none;stroke:#35a4dd;stroke-width:65;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.trash_svg__st5{stroke:#f9af17}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M183.4 218.9L253.8 983h516.4l38.5-418.3M91.3 201.1h841.4M339 41.7h337v159.4H339z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M512 802.2V353.8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 817.4,
    cy: 468.9,
    r: 32.6,
    fill: "#35a4dd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M642 802.2V353.8M380.6 802.2V353.8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#35a4dd",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 65,
    d: "M826.4 373.2l14.2-155"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default ForwardRef;